module.exports = __webpack_public_path__ + "static/media/5.9e682ce8.png";